export const isAppleDevice = /Mac|iPad|iPhone|iPod/.test(navigator.platform || "")
export const isChromium = /Chrome/.test(navigator.userAgent || "")